/* eslint eslint-comments/no-unlimited-disable: off */
/* eslint-disable */
// @ts-nocheck
// automatically generated by the FlatBuffers compiler, do not modify
export class Uuid {
    bb = null;
    bb_pos = 0;
    __init(i, bb) {
        this.bb_pos = i;
        this.bb = bb;
        return this;
    }
    lower() {
        return this.bb.readUint64(this.bb_pos);
    }
    higher() {
        return this.bb.readUint64(this.bb_pos + 8);
    }
    static sizeOf() {
        return 16;
    }
    static createUuid(builder, lower, higher) {
        builder.prep(8, 16);
        builder.writeInt64(BigInt(higher ?? 0));
        builder.writeInt64(BigInt(lower ?? 0));
        return builder.offset();
    }
}
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoidXVpZC5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uLy4uLy4uL3NyYy9saWIvZ2VuZXJhdGVkL2Zicy9ydmFpL3V1aWQudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUssc0RBQXNEO0FBQ3RELG9CQUFvQjtBQUNwQixjQUFjO0FBQ2xCLHFFQUFxRTtBQUl0RSxNQUFNLE9BQU8sSUFBSTtJQUNmLEVBQUUsR0FBZ0MsSUFBSSxDQUFDO0lBQ3ZDLE1BQU0sR0FBRyxDQUFDLENBQUM7SUFDWCxNQUFNLENBQUMsQ0FBUSxFQUFFLEVBQXlCO1FBQzFDLElBQUksQ0FBQyxNQUFNLEdBQUcsQ0FBQyxDQUFDO1FBQ2hCLElBQUksQ0FBQyxFQUFFLEdBQUcsRUFBRSxDQUFDO1FBQ2IsT0FBTyxJQUFJLENBQUM7SUFDZCxDQUFDO0lBRUQsS0FBSztRQUNILE9BQU8sSUFBSSxDQUFDLEVBQUcsQ0FBQyxVQUFVLENBQUMsSUFBSSxDQUFDLE1BQU0sQ0FBQyxDQUFDO0lBQzFDLENBQUM7SUFFRCxNQUFNO1FBQ0osT0FBTyxJQUFJLENBQUMsRUFBRyxDQUFDLFVBQVUsQ0FBQyxJQUFJLENBQUMsTUFBTSxHQUFHLENBQUMsQ0FBQyxDQUFDO0lBQzlDLENBQUM7SUFFRCxNQUFNLENBQUMsTUFBTTtRQUNYLE9BQU8sRUFBRSxDQUFDO0lBQ1osQ0FBQztJQUVELE1BQU0sQ0FBQyxVQUFVLENBQUMsT0FBMkIsRUFBRSxLQUFhLEVBQUUsTUFBYztRQUMxRSxPQUFPLENBQUMsSUFBSSxDQUFDLENBQUMsRUFBRSxFQUFFLENBQUMsQ0FBQztRQUNwQixPQUFPLENBQUMsVUFBVSxDQUFDLE1BQU0sQ0FBQyxNQUFNLElBQUksQ0FBQyxDQUFDLENBQUMsQ0FBQztRQUN4QyxPQUFPLENBQUMsVUFBVSxDQUFDLE1BQU0sQ0FBQyxLQUFLLElBQUksQ0FBQyxDQUFDLENBQUMsQ0FBQztRQUN2QyxPQUFPLE9BQU8sQ0FBQyxNQUFNLEVBQUUsQ0FBQztJQUMxQixDQUFDO0NBRUEifQ==